import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";
const ReceiveConfirmationDialog = ({
  isOpen,
  onConfirm,
  onCancel,
  hasFreeGoods
}) => {
  return (
    isOpen && (
      <SweetAlert
      warning
      title={"Please check and confirm all data is correct. And check below" }
        showCancel
        confirmBtnText="Yes, Receive"
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        onConfirm={onConfirm}
        onCancel={onCancel}
      >
        {hasFreeGoods ? (
          <div>
            {/* <p>Please confirm and verify:</p> */}
            <ul className="list-unstyled">
              <li>
                <i className="mdi mdi-check-circle text-success mr-2"></i>
                All quantities are correctly entered
              </li>
              <li>
                <i className="mdi mdi-check-circle text-success mr-2"></i>
                All expiry dates are set
              </li>
              <li>
                <i className="mdi mdi-check-circle text-success mr-2"></i>
                Free goods quantities are properly filled
              </li>
              <li>
                <i className="mdi mdi-check-circle text-success mr-2"></i>
                Invoice details are correct
              </li>
            </ul>
          </div>
        ) : (
          <div>
            {/* <p>Please confirm:</p> */}
            <ul className="list-unstyled">
              <li>
                <i className="mdi mdi-alert-circle text-warning mr-2"></i>
                If you have received any free goods, please add them before proceeding
              </li>
              <li>
                <i className="mdi mdi-check-circle text-success mr-2"></i>
                All quantities are correctly entered
              </li>
              <li>
                <i className="mdi mdi-check-circle text-success mr-2"></i>
                All expiry dates are set
              </li>
              <li>
                <i className="mdi mdi-check-circle text-success mr-2"></i>
                Invoice details are correct
              </li>
            </ul>
          </div>
        )}
      </SweetAlert>
    )
  );
};

export default ReceiveConfirmationDialog;